/** @type {import('../schema').ProcessDefinition} */
const empleados = {
  id: "empleados",
  name: "Empleados: alta, turnos y asistencia",
  category: "personas",
  outcome:
    "Gestionar al personal del edificio (porteros, limpieza), sus turnos de trabajo (employee_shifts) y su asistencia con check-in/out por geolocalización.",
  trigger:
    "El Administrador da de alta/gestiona empleados y arma su agenda; el Empleado marca entrada/salida.",
  actors: ["Administrador", "Empleado", "Sistema"],
  status: "COMPLETO",
  description:
    "Módulo de personal del edificio: alta y asignación, definición de turnos, check-in/out validado por geofencing, monitoreo de asistencia y panel propio del empleado (tareas, incidentes, solicitudes, recibos, chat).",
  lanes: [
    { id: "admin", actor: "Administrador" },
    { id: "emp", actor: "Empleado" },
    { id: "sys", actor: "Sistema" },
  ],
  steps: [
    { id: "s1", laneId: "admin", type: "start", label: "Alta y asignación del empleado", description: "Crea el empleado (typeuser 3) y lo asocia al edificio; opcional cuenta de acceso.", evidence: "src/screens/admin/TurnosAdmin.jsx" },
    { id: "s2", laneId: "admin", type: "task", label: "Define turnos", description: "Configura turnos por día y horario." },
    { id: "s3", laneId: "emp", type: "task", label: "Intenta marcar entrada/salida", description: "El empleado hace check-in o check-out desde su panel.", evidence: "src/screens/employee/CheckInOut.jsx" },
    { id: "s4", laneId: "sys", type: "decision", label: "¿Dentro del radio permitido?", description: "El sistema valida la distancia al edificio (geofencing) antes de permitir.", evidence: "src/utils/geofencing.js" },
    { id: "s5", laneId: "emp", type: "task", label: "Marca rechazada", description: "Geolocalización denegada o fuera de radio: no permite marcar." },
    { id: "s6", laneId: "sys", type: "task", label: "Registra asistencia", description: "Estado checked_in → checked_out; registra entrada, salida, horas y tardanzas." },
    { id: "s7", laneId: "admin", type: "task", label: "Monitorea la asistencia", description: "Ve entrada, salida, horas y tardanzas del personal.", evidence: "src/screens/admin/AsistenciaEmpleados.jsx" },
    { id: "s8", laneId: "emp", type: "end", label: "Operación del empleado", description: "Desde su panel el empleado opera sus procesos dedicados: tareas, solicitudes/licencias, chat interno, incidencias y recibos." },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s3" },
    { from: "s3", to: "s4" },
    { from: "s4", to: "s6", label: "sí" },
    { from: "s4", to: "s5", label: "no" },
    { from: "s5", to: "s3" },
    { from: "s6", to: "s7" },
    { from: "s7", to: "s8" },
  ],
};

export default empleados;
